export default {
  '上海松江区爱菊学校': 'Shanghai Songjiang Aiju School',
  '地址': 'Address: No. 100 East Wenjun Road, Songjiang, Shanghai',
  '小初': 'Primary & Junior High: +86 18017147170',
  '高中': 'Senior High: +86 18621521084',
  '爱菊教育': 'Aiju Education',
  '新闻与活动': 'News & Events',
  '查看更多': 'View More',
  '联系我们': 'Contact Us',
  '关于我们': 'About Us',
  '期待': 'We look forward to the arrival of parents and students',
  '小初部联系': 'Primary & Junior High: +86 18017147170',
  '高中部联系': 'Senior High: +86 18621521084',
  '小初公众号二维码': 'Primary & Junior High Official QR Code',
  '高中公众号二维码': 'Senior High Official QR Code',
  '探索更多': 'Explore More',
};
